import script from "./GenericButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./GenericButton.vue?vue&type=script&setup=true&lang=ts"

import "./GenericButton.vue?vue&type=style&index=0&id=0c27cba6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c27cba6"]])

export default __exports__